import { http, prmHttp } from './index';
import Axios from '../utils/axios';


//分页查询团队列表
export const getPersonalManageList = (params: any) => http.post('/teaching-workbench/booking/service-team-list',params);

//创建团队列表
export const addTeam = (params: {serviceTeamId:number,serviceTeamName:string,projectId:number,projectName:string,roleId:number,teamType:number}) => http.post('/teaching-workbench/booking/add/service/team',params);

//启用禁用状态
export const editTeamStatus = (params: { id: number, status: number }) => http.post('/teaching-workbench/booking/team-setting/edit', params);

export const editTeam = (params: {id: number,serviceTeamId:number,serviceTeamName:string,projectId:number,projectName?:string,roleId:number,teamType:number}) => http.post('/teaching-workbench/booking/team-setting/edit', params);

//根据团队ID获取团队名称、项目名称
export const getTeamById = (id:any) => prmHttp.get(`/admin/v2/dict/basic/id?id=${id}`);

//获取角色list
export const getRoleList = () => http.get('/vigo/web/v2/roles/all?appId=211004&roleType=1');

//获取所属项目列表
export const getProjectOptions = () => prmHttp.get('/api/v2/dict/basic?typeId=1602');
